import { toUpdateReviewRequest } from '../models/mapper'
import { updateReviewStatusV2 } from './http'

// eslint-disable-next-line import/prefer-default-export
export async function updateReviewStatus(id: number, isReviewed: boolean) {
  if (id === null || id === undefined) {
    throw new Error('Transit Operation ID cannot be null or undefined!')
  }
  return updateReviewStatusV2(id, toUpdateReviewRequest(isReviewed))
}
